import { createSlice, PayloadAction } from '@reduxjs/toolkit';

type LocationState = {
  previousLocationPath: string;
  locationPath: string;
};

const initialState: LocationState = {
  previousLocationPath: '',
  locationPath: '',
};

const locationSlice = createSlice({
  name: 'location',
  initialState,
  reducers: {
    setLocationPath(state, action: PayloadAction<string>) {
      state.previousLocationPath = state.locationPath;
      state.locationPath = action.payload;
    },
  },
});

export const { setLocationPath } = locationSlice.actions;
export default locationSlice.reducer;
